/* <size-guide>: the size chart drawer on the shared drawer-dialog controller.
 * Any [data-size-guide-open] whose aria-controls names this dialog opens it.
 * The trigger is a link to the sizing page; it is followed unless the drawer opened. */
if (!customElements.get('size-guide')) {
  customElements.define('size-guide', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      const dialog = this.querySelector('dialog');
      this.drawer = new window.AsansaraDrawer(dialog, '[data-size-guide-close]');
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-size-guide-open]');
        if (!trigger || trigger.getAttribute('aria-controls') !== dialog.id) return;
        // A modified or non-primary click keeps the link's own behaviour (new tab, new window).
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        this.drawer.open(trigger);
        event.preventDefault();
      }, { signal: this.events.signal });
    }

    disconnectedCallback() {
      this.events.abort();
      this.drawer?.destroy();
    }
  });
}
